/** Keep the visible wake behind the direction of travel, including sternway. */
import { Vector3 } from 'three/webgpu'
import type { Tug } from '../entities/Tug.ts'
import type { WakeSource } from './Ocean.ts'

export class PlayerWake {
  private reversing = false
  private vessel: Tug | null = null
  private readonly origin = new Vector3()
  private readonly source: WakeSource = { x: 0, z: 0, yaw: 0, speed: 0, wash: 0, halfBeam: 1 }

  update(tug: Tug): WakeSource {
    if (this.vessel !== tug) {
      this.vessel = tug
      this.reversing = false
    }
    // Follow motion, not the throttle: braking ahead must not flip the wake
    // before the boat actually starts moving astern. Hold direction near zero
    // to prevent buoyancy/contact noise from flickering between bow and stern.
    if (Math.abs(tug.forwardSpeed) > .15) {
      this.reversing = tug.forwardSpeed < 0
    } else if (tug.speed < .15 && Math.abs(tug.throttle) > .02) {
      this.reversing = tug.throttle < 0
    }

    if (this.reversing) this.origin.set(0, 0, tug.config.length * .5)
    else this.origin.copy(tug.attachments.propeller)
    tug.localToWorld(this.origin, this.origin)

    this.source.x = this.origin.x
    this.source.z = this.origin.z
    this.source.yaw = tug.yaw + (this.reversing ? Math.PI : 0)
    this.source.speed = tug.speed
    this.source.wash = Math.abs(tug.throttle)
    this.source.halfBeam = tug.config.beam * .5
    return this.source
  }
}
